import type { CardProps } from '@mui/material/Card';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { Skeleton, Typography } from '@mui/material';

// ----------------------------------------------------------------------

type Props = CardProps & {
  title: string;
  total: string;
  percent?: number;
  loading?: boolean;
  currency?: boolean;
  footer?: React.ReactNode;
};

export function ReportWidget({
  sx,
  title,
  total,
  loading = false,
  currency = false,
  footer,
  ...other
}: Props) {
  return (
    <Card
      sx={[
        () => ({
          p: 3,
          display: 'flex',
          zIndex: 'unset',
          overflow: 'unset',
          alignItems: 'center',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2">
          {loading ? <Skeleton variant="rounded" width="100px" /> : title}
        </Typography>
        <Typography variant="h3" sx={{ mt: 1.5, mb: 1 }}>
          {loading ? <Skeleton width="150px" variant="rounded" /> : total}
        </Typography>
        {footer}
      </Box>
    </Card>
  );
}
